

import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo} from "../Configuracion";
import {
    CELLTIPO_CADENA,
    CELLTIPO_ENTERO,
    CELLTIPO_FOREIGN,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import {CAMPOTIPO_CADENA} from "../../framework2/ej2/UI/TiposCampos";
import Formulario from "../../framework2/ej2/UI/Formulario";
import {getElementoConfigNombre, getGridConfigNombre} from "../../framework2/ej2/utils/CrudUtilsJPA";
import {BOTONERA_REFRESCAR} from "../../framework2/ej2/UI/FormularioBotonera";


import Calendario from "../../framework2/ej2/UI/Calendario";
import "../resources/css/calendario.css";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {loadDatosServicio, postServicio, renderFormulario} from "../utils/FormularioUtils";
import Tratamiento from "../general/Tratamiento";
import Cita from "./Cita";
import Pacientes from "../general/Pacientes";
import DialogoSiNo from "../../framework2/ej2/UI/DialogoSiNo";
import CitasLista from "../general/CitasLista";
import {Icon, Intent, Spinner} from "@blueprintjs/core";
import {getFormattedDateInversaFromDate, getMesAgno} from "../../framework2/ej2/utils/DateUtils";

const MODO_MOSTRAR_CITAS= 'MODO_MOSTRAR_CITAS';
const MODO_MOSTRAR_CITA= 'MODO_MOSTRAR_CITA';
const MODO_MOSTRAR_PACIENTE= 'MODO_MOSTRAR_PACIENTE';
const MODO_MOSTRAR_LISTACITAS= 'MODO_MOSTRAR_LISTACITAS';


//import Calendario from "../../framework2/bigcalendar/Calendario";
class Citas extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            fecha: new Date(),
            citas: [],

            cita: null,
            paciente: null,
            modo: MODO_MOSTRAR_CITAS,
            fechaActual: new Date(),

            dialogoEliminarMostrar: false,
            dialogoEliminarTitulo: "",
            dialogoEliminarMensaje: "",
            eventoSeleccionadoEliminar: null,

            mesPivoteCargado: null,
            cargandoDatos: false,
        }


    }

    componentDidMount() {
        this.refrescarCitas();
    }


    // --------------------------------------------------------------------------------------
    // FUNCIONES DE FECHA
    // --------------------------------------------------------------------------------------

    fechaActualModificada = (newFecha) => {
        console.log("--- fechaActualModificada ---- ", newFecha);
        this.setState({fechaActual: newFecha}, () => this.refrescarCitas());

    };

    refrescarCitas = (forzar) => {
        const{fechaActual, mesPivoteCargado} = this.state;

        let bForzar= forzar != undefined ? Boolean(forzar) : false;

        let mes = getMesAgno(fechaActual);
        if (bForzar || !mesPivoteCargado || !this.mesIgual(mesPivoteCargado, mes)){
            this.loadCitasConMesPivote(fechaActual);
        }
    }

    loadCitasConMesPivote= (date) => {
        const {fechaActual} = this.state;
        const {auth, estado} = this.props;

        let dateReal= date ? date : fechaActual;

        //Obtenemos rangos y mes pivote.
        let intervalo= this.calcularIntervaloDesdeFecha(dateReal);
        const { desde, hasta } = this.calcularIntervaloDesdeFecha(dateReal);
        const mesAgno = getMesAgno(dateReal);

        this.setState({ cargandoDatos: true });

        let parametros= {
            usuarioCodigo: auth.usuarioCodigo,
            clinicaCodigo: estado.clinica.codigo,
            desde: getFormattedDateInversaFromDate(desde),
            hasta: getFormattedDateInversaFromDate(hasta),
        }
        loadDatosServicio(this, "Cita", "getCitas", parametros, (datos) => {
                let citas= this.transformarCitas(datos);
                if (date)
                    this.setState({fechaActual: date, citas: citas, mesPivoteCargado: mesAgno, cargandoDatos: false,});
                else
                    this.setState({citas: citas, mesPivoteCargado: mesAgno, cargandoDatos: false,});
            },
            () => {
                this.setState({cargandoDatos: false,});
            });


    }

    calcularIntervaloDesdeFecha(date) {
        //Mes actual
        const desde = new Date(date.getFullYear(), date.getMonth() , 1);
        const hasta = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
        console.log("calcularIntervaloDesdeFecha: ", desde, " - ", hasta);
        return { desde, hasta };
    }

    mesIgual(a, b) {
        return a.agno === b.agno && a.mes === b.mes;
    }

    // --------------------------------------------------------------------------------------
    // FUNCIONES DE CITAS
    // --------------------------------------------------------------------------------------


    transformarCitas= (citasOriginales) => {
        citasOriginales.forEach( (cita, index) => {
            cita.start= new Date(cita.fechainicio);
            cita.end= new Date(cita.fechafin);
        });
        return citasOriginales;
    }


    nuevaCita= (rangoSeleccionado) => {
        const {fechaActual} = this.state;
        const {estado} = this.props;
        let tsFechaInicio= 0;
        let tsFechaFin= 0;

        if (rangoSeleccionado.start){
            let fechaInicio=  rangoSeleccionado.start;
            tsFechaInicio= fechaInicio.getTime();
            let fechaFin=  rangoSeleccionado.end;
            tsFechaFin= fechaFin.getTime();
        }
        else{
            let fechaInicio=  fechaActual;
            fechaInicio.setHours(8,0,0);
            tsFechaInicio= fechaInicio.getTime();

            let fechaFin=  fechaActual;
            fechaFin.setHours(8,30,0);
            tsFechaFin= fechaFin.getTime();
        }


        let citaNew= {
            fechainicio: tsFechaInicio,
            fechafin: tsFechaFin,
            sinhora: false,
            clinicaCodigo: estado.clinica,
            avisoestado: 0,
        }

        this.setState({cita: citaNew, modo: MODO_MOSTRAR_CITA});
    }


    onEventoSeleccionado= (evento) => {
        const { start, end, ...cita } = evento;
        this.setState({cita: cita, modo: MODO_MOSTRAR_CITA});
    }
    modificarCita= (cita) =>{
        this.setState({cita: cita, modo: MODO_MOSTRAR_CITA});
    }

    onAceptarCita= () => {
        this.setState({modo: MODO_MOSTRAR_CITAS}, this.loadCitasConMesPivote);
    }

    onPacienteClick= (evento) => {
        this.setState({paciente: evento.pacienteCodigo, modo: MODO_MOSTRAR_PACIENTE});
    }
    onEventoBorrar= (evento) => {
        //console.log ("ON EVENTO BORRAR");
        //console.log("evento: ", evento);

        // Formato día-mes-año
        const cadFecha = new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(evento.start);
        // Formato hora:minutos (24h)
        const cadHoraInicio = new Intl.DateTimeFormat('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false }).format(evento.start);
        const cadHoraFin = new Intl.DateTimeFormat('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false }).format(evento.end);

        let mensaje= "Cita del paciente " + evento.pacienteCodigo.nombre + " el día " + cadFecha + " en el periodo " + cadHoraInicio + " -> " + cadHoraFin;
        this.setState({dialogoEliminarTitulo: "¿Desea eliminar el evento? ",
                             dialogoEliminarMensaje: mensaje,
                             dialogoEliminarMostrar: true,
                             eventoSeleccionadoEliminar: evento});
    }
    onEventoEliminarQuestion= (aceptado) => {
        const {auth} = this.props;
        //console.log("onEventoEliminarQuestion: ", aceptado);
        if(aceptado){
            const {eventoSeleccionadoEliminar} = this.state;
            let parametros= {
                usuarioCodigo: auth.usuarioCodigo,
                citaCodigo: eventoSeleccionadoEliminar.codigo,
            }
            postServicio(this, "Cita", "eliminar", parametros, () => {
                this.setState({dialogoEliminarTitulo: "", dialogoEliminarMensaje: "", dialogoEliminarMostrar:false, eventoSeleccionadoEliminar: null},
                    () => this.refrescarCitas(true));
            });
        }
        else {
            this.setState({dialogoEliminarTitulo: "", dialogoEliminarMensaje: "", dialogoEliminarMostrar: false, eventoSeleccionadoEliminar: null});
        }

    }

    render() {
        const {fechaActual, cargandoDatos,citas, cita, paciente, modo,
               dialogoEliminarMostrar, dialogoEliminarTitulo, dialogoEliminarMensaje,} = this.state;

        //console.log ("RENDER ----- ");
        //console.log("fechaActual: ", fechaActual);

        const sFecha = fechaActual.toLocaleDateString("es-ES", {
            weekday: "long",   // "jueves"
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
        let tituloDia= "CITAS DEL DIA " + sFecha;

        return (
            <div>
                <DialogoSiNo mostrar={dialogoEliminarMostrar} titulo={dialogoEliminarTitulo} mensaje={dialogoEliminarMensaje}
                             onClose={() => this.setState({dialogoEliminarMostrar: false})}
                             onQuestion={this.onEventoEliminarQuestion}
                             />

                { (modo == MODO_MOSTRAR_CITAS && cargandoDatos) && <Spinner intent={Intent.PRIMARY} size={50} /> }
                { (modo == MODO_MOSTRAR_CITAS && !Boolean(cargandoDatos)) &&
                    <>
                        <Calendario fecha={fechaActual}
                                    eventos={citas}
                                    onEventoSeleccionado={this.onEventoSeleccionado}
                                    onPacienteClick={this.onPacienteClick}
                                    onEventoBorrar={this.onEventoBorrar}
                                    onFechaActualModificada={this.fechaActualModificada}
                                    onHoraDobleClick={ (rango) => {
                                        this.nuevaCita(rango);
                                        }
                                    }
                        />
                        <button className="fr_boton aceptar"onClick={this.nuevaCita}><Icon icon="document" style={{marginRight: 6}}/>Nueva cita</button>
                        <button className="fr_boton refrescar" onClick={() => {this.setState({modo: MODO_MOSTRAR_LISTACITAS})}}><Icon icon="calendar"/> Citas del día</button>
                        <button className="fr_boton refrescar"onClick={this.refrescarCitas}><Icon icon="refresh" style={{marginRight: 6}}/>Refrescar</button>
                        {/* <button className="fr_boton refrescar" onClick={() => {this.setState({modo: MODO_MOSTRAR_LISTACITAS})}}><Icon icon="calendar"/> Consultar citas</button>*/}
                    </>
                }
                {modo == MODO_MOSTRAR_CITA && <Cita elemento={cita}
                                            onAceptar={ this.onAceptarCita}
                                            onCancelar={() => this.setState({modo: MODO_MOSTRAR_CITAS}) }  />}
                {modo == MODO_MOSTRAR_PACIENTE && <Pacientes pacienteCodigo={paciente.codigo}
                                            onAceptarPaciente={() => this.setState({modo: MODO_MOSTRAR_CITAS}) }  />}
                {modo == MODO_MOSTRAR_LISTACITAS && <CitasLista
                    fecha={fechaActual}
                    titulo={tituloDia}
                    onSalir={() => this.setState({modo: MODO_MOSTRAR_CITAS}) }
                />}

            </div>
        )
    }

}

Citas.propTypes = {

}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        estado: state.estado,
        datosmaestros: state.datosmaestros,
    }
}
export default connect(mapStateToProps)(Citas);



